/**
 * @generated SignedSource<<2b6bd7efb3daf817d0b973cd68576df1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type ProjectHeaderRefreshedQuery$variables = {
  key: string;
  trackViewEvent?: TrackViewEvent | null;
};
export type ProjectHeaderRefreshedQuery$data = {
  readonly project: {
    readonly archived: boolean;
    readonly key: string;
    readonly members: {
      readonly " $fragmentSpreads": FragmentRefs<"utils_isUserInList">;
    } | null;
    readonly private: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"MetaActions" | "ProjectIconPicker" | "ProjectTabsRefreshed" | "ProjectTitle">;
  } | null;
};
export type ProjectHeaderRefreshedQuery = {
  response: ProjectHeaderRefreshedQuery$data;
  variables: ProjectHeaderRefreshedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "trackViewEvent"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "key"
},
v3 = {
  "kind": "ScalarField",
  "name": "private"
},
v4 = {
  "kind": "ScalarField",
  "name": "archived"
},
v5 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v10 = {
  "kind": "ScalarField",
  "name": "count"
},
v11 = [
  (v10/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "ari"
},
v13 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v14 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v15 = {
  "kind": "ScalarField",
  "name": "picture"
},
v16 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v17 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "value"
},
v19 = {
  "kind": "ScalarField",
  "name": "summary"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectHeaderRefreshedQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v1/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "utils_isUserInList",
                "selections": [
                  {
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "argumentDefinitions": []
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "ProjectTitle"
          },
          {
            "kind": "FragmentSpread",
            "name": "ProjectIconPicker"
          },
          {
            "kind": "FragmentSpread",
            "name": "ProjectTabsRefreshed"
          },
          {
            "kind": "FragmentSpread",
            "name": "MetaActions"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectHeaderRefreshedQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v1/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              {
                "concreteType": "UserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v7/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "color"
              },
              {
                "kind": "ScalarField",
                "name": "shortName"
              }
            ]
          },
          {
            "concreteType": "IconURIs",
            "kind": "LinkedField",
            "name": "iconUrl",
            "plural": false,
            "selections": [
              {
                "concreteType": "ThemeURIs",
                "kind": "LinkedField",
                "name": "square",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "light"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "dark"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "transparent"
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "watching"
          },
          {
            "kind": "ScalarField",
            "name": "userUpdateCount"
          },
          {
            "alias": "learningsCount",
            "args": [
              (v9/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "LEARNING"
              }
            ],
            "concreteType": "LearningConnection",
            "kind": "LinkedField",
            "name": "learnings",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": "learnings(first:100,type:\"LEARNING\")"
          },
          {
            "alias": "risksCount",
            "args": [
              (v9/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "RISK"
              }
            ],
            "concreteType": "LearningConnection",
            "kind": "LinkedField",
            "name": "learnings",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": "learnings(first:100,type:\"RISK\")"
          },
          {
            "alias": "decisionsCount",
            "args": [
              (v9/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "DECISION"
              }
            ],
            "concreteType": "LearningConnection",
            "kind": "LinkedField",
            "name": "learnings",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": "learnings(first:100,type:\"DECISION\")"
          },
          {
            "kind": "ScalarField",
            "name": "theWhat"
          },
          {
            "kind": "ScalarField",
            "name": "theWhy"
          },
          {
            "kind": "ScalarField",
            "name": "theMeasurement"
          },
          {
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v6/*: any*/),
              {
                "concreteType": "WorkspaceAIConfig",
                "kind": "LinkedField",
                "name": "aiConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "enabled"
                  }
                ]
              }
            ]
          },
          (v12/*: any*/),
          {
            "concreteType": "CommentConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
              {
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v13/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "commentText"
                      },
                      (v14/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v7/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "accountStatus"
                              },
                              (v16/*: any*/)
                            ]
                          },
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v17/*: any*/)
            ]
          },
          {
            "concreteType": "ProjectState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              {
                "concreteType": "CompletionProjectState",
                "kind": "LinkedField",
                "name": "atCompletionState",
                "plural": false,
                "selections": [
                  (v18/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "targetDate"
          },
          {
            "kind": "ScalarField",
            "name": "targetDateConfidence"
          },
          {
            "kind": "ScalarField",
            "name": "latestUpdateDate"
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": (v11/*: any*/)
          },
          (v14/*: any*/),
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          {
            "concreteType": "ProjectUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              (v19/*: any*/),
              {
                "concreteType": "UpdateNote",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "title"
                  },
                  (v19/*: any*/),
                  (v6/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "hasUpdateId",
                "value": false
              }
            ],
            "concreteType": "ProjectChangelogItemConnection",
            "kind": "LinkedField",
            "name": "changelog",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "concreteType": "ProjectChangelogItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ProjectChangelogItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "newValue"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "oldValue"
                      },
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "changelog(hasUpdateId:false)"
          },
          {
            "concreteType": "DraftUpdate",
            "kind": "LinkedField",
            "name": "draftUpdate",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "input"
              },
              {
                "kind": "ScalarField",
                "name": "modifiedDate"
              },
              {
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserPII",
                    "kind": "LinkedField",
                    "name": "pii",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v7/*: any*/),
                      (v15/*: any*/)
                    ]
                  },
                  (v6/*: any*/)
                ]
              },
              (v6/*: any*/),
              (v17/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "concreteType": "TownsquareProjectCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canWatchProject"
              },
              {
                "kind": "ScalarField",
                "name": "canArchiveProject"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0c1b3b5e74b8ff852aead944483c2b2a",
    "id": null,
    "metadata": {},
    "name": "ProjectHeaderRefreshedQuery",
    "operationKind": "query",
    "text": "query ProjectHeaderRefreshedQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n) {\n  project: projectByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    key\n    private\n    archived\n    members {\n      ...utils_isUserInList\n    }\n    ...ProjectTitle\n    ...ProjectIconPicker\n    ...ProjectTabsRefreshed\n    ...MetaActions\n    id\n  }\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment DraftProjectUpdate on DraftUpdate {\n  input\n  modifiedDate\n  author {\n    pii {\n      accountId\n      name\n      picture\n    }\n    id\n  }\n}\n\nfragment InviteUserPromptPopup on Project {\n  watchers {\n    count\n  }\n}\n\nfragment MetaActions on Project {\n  key\n  private\n  ...ProjectStateAndTargetDate\n  ...ProjectFollowButton\n  ...InviteUserPromptPopup\n  ...ProjectActions\n}\n\nfragment NewProjectUpdate on Project {\n  id\n  key\n  uuid\n  workspace {\n    uuid\n    id\n  }\n  watchers {\n    count\n  }\n  creationDate\n  startDate\n  targetDate\n  state {\n    value\n  }\n  latestUserUpdate {\n    editDate\n    creationDate\n    summary\n    notes {\n      title\n      summary\n      id\n    }\n    id\n  }\n  ...ProjectTargetDateAutoUpdated\n  draftUpdate {\n    ...DraftProjectUpdate\n    input\n    id\n  }\n  url\n}\n\nfragment ProjectAboutTab on Project {\n  ...ProjectDescription\n  ...ProjectComments\n}\n\nfragment ProjectActions on Project {\n  id\n  ari\n  name\n  archived\n  private\n  capabilities {\n    canArchiveProject\n  }\n}\n\nfragment ProjectComments on Project {\n  id\n  uuid\n  ari\n  workspace {\n    uuid\n    id\n  }\n  comments {\n    edges {\n      node {\n        id\n      }\n    }\n    ...Comments\n  }\n}\n\nfragment ProjectDescription on Project {\n  id\n  uuid\n  name\n  theWhat\n  theWhy\n  theMeasurement\n  workspace {\n    uuid\n    id\n  }\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  ari\n  uuid\n  watching\n  capabilities {\n    canWatchProject\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectIconPicker on Project {\n  id\n  uuid\n  icon {\n    id\n    color\n    shortName\n  }\n  ...ProjectIcon\n}\n\nfragment ProjectStateAndTargetDate on Project {\n  state {\n    value\n    atCompletionState {\n      value\n    }\n  }\n  creationDate\n  startDate\n  targetDate\n  targetDateConfidence\n}\n\nfragment ProjectTabsRefreshed on Project {\n  key\n  watching\n  userUpdateCount\n  learningsCount: learnings(first: 100, type: LEARNING) {\n    count\n  }\n  risksCount: learnings(first: 100, type: RISK) {\n    count\n  }\n  decisionsCount: learnings(first: 100, type: DECISION) {\n    count\n  }\n  ...ProjectAboutTab\n  ...ProjectUpdatesTab\n}\n\nfragment ProjectTargetDateAutoUpdated on Project {\n  key\n  targetDate\n  changelog(hasUpdateId: false) {\n    count\n    edges {\n      node {\n        newValue\n        oldValue\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectTitle on Project {\n  name\n  id\n}\n\nfragment ProjectUpdateComposer on Project {\n  ...ProjectUpdateDueDateContext\n  ...NewProjectUpdate\n  draftUpdate {\n    ...DraftProjectUpdate\n    id\n  }\n  id\n  uuid\n  workspace {\n    uuid\n    aiConfig {\n      enabled\n    }\n    id\n  }\n}\n\nfragment ProjectUpdateDueDateContext on Project {\n  state {\n    value\n  }\n  latestUpdateDate\n}\n\nfragment ProjectUpdatesTab on Project {\n  key\n  state {\n    value\n  }\n  watching\n  targetDate\n  targetDateConfidence\n  ...ProjectUpdateComposer\n  draftUpdate {\n    id\n  }\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment utils_isUserInList on UserConnection {\n  edges {\n    node {\n      aaid\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dae54e3e82bec4bf02efc13fb70a90d2";

export default node;
